import type { UploadFile } from 'antd/es/upload/interface';

import landscapeOverlayImg from '../assets/landscape-overlay.png';
import personImg from '../assets/person.png';

import { S3_BUCKET_URL } from '../constants';
import { Event, PublicEvent, Person, File } from '../types';

export const getFileUrl = (
  fileId: string,
  fileName: string,
  extension?: string,
  time?: number,
  showPreview?: boolean,
) => {
  let url =
    `${S3_BUCKET_URL}.files/${fileId}/` +
    (showPreview ? 'preview-' : '') +
    encodeURIComponent(fileName);

  if (extension) url += '.' + extension;
  if (time) url += '#t=' + time;

  return url;
};

export const getFileImg = (file: File | null | undefined) => {
  if (file?.url) return file.url;

  return file && file.fileType === 'image'
    ? getFileUrl(file.elementId, file.name)
    : personImg;
};

export const getThumbnail = (frameId?: string | null) => {
  return frameId
    ? `${S3_BUCKET_URL}.thumbnails/${frameId}/720x405.png`
    : landscapeOverlayImg;
};

export const getEventImg = (type: string, eventImageLocation?: string) => {
  const imageKey = eventImageLocation
    ? eventImageLocation
    : `default/default-${type}.png`;
  return `${S3_BUCKET_URL}.files/${imageKey}`;
};

// convert uploaded image to base64 for preview
export const getBase64 = (
  uploadFile: UploadFile | File,
  callback: (result: string) => void,
) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => {
    if (reader.result && typeof reader.result === 'string') {
      callback(reader.result);
    }
  });

  const file = (uploadFile as any).originFileObj || uploadFile;
  reader.readAsDataURL(file);
};

export const getShotImage = (type: string) => {
  const s3Folder =
    'https://crowdclip-media-assets.s3.ap-southeast-2.amazonaws.com/shot-image/';

  return s3Folder + (type === 'zip' ? 'shot-images.zip' : `shot-${type}.png`);
};

export const getCreationVideoUrl = (
  event: Event | PublicEvent | null,
  person: Person | null,
) => {
  return `${S3_BUCKET_URL}.files${encodeURIComponent((event?.payment?.paid || person?.face?.payment?.paid ? person?.finalVideoUri : person?.previewVideoUri) ?? '')}`;
};
